import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-4",
  "use": "icon-4-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol viewBox=\"0 0 25 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-4\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.5 23C13.6 23 14.5 22.1 14.5 21H10.5C10.5 22.1 11.4 23 12.5 23V23ZM19 17V11.5C19 8.43 16.87 5.86 14 5.18V4.5C14 3.67 13.33 3 12.5 3C11.67 3 11 3.67 11 4.5V5.18C8.13 5.86 6 8.43 6 11.5V17L4 19V20H21V19L19 17V17Z\" fill=\"#898989\" />\r\n<circle cx=\"20\" cy=\"5\" r=\"4\" fill=\"#F9837C\" stroke=\"white\" stroke-width=\"2\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol